import { Draft } from 'immer';
import { produce } from "immer";
import { EventoStore } from "./evento";

export interface CompraStatus {
    status: 'nueva' | 'pendiente' | 'en proceso' | 'confirmada' | 'rechazada' | null;
    message: string;
    compraId: string | null;
    tickets?: Array<{
        id: string;
        codigo: string;
        tipoEntradaId: string;
        status: string;
        QR?: string;
        mesa?: string | null;
        asiento?: string | null;
    }>;
    pdfUrl?: string | null;
    accessToken?: string | null;
}

export interface CompraSlice {
    state: CompraStatus;
    set: (compra: CompraStatus) => void;
    clear: () => void;
}

export const createCompraSlice = (set: any): CompraSlice => ({
    state: {
        status: 'nueva',
        message: '',
        compraId: null,
        tickets: [],
        pdfUrl: null,
    },
    set: (compra) => set(produce((state: Draft<EventoStore>) => { state.compra.state = compra; })),
    clear: () => set(produce((state: Draft<EventoStore>) => {
        state.compra.state = {
            status: 'nueva',
            message: '',
            compraId: null,
            tickets: [],
        };
    })),
});

